export const productionLanguageCodes = ["en", "nl", "de"] as const;

export type ProductionLanguageCode = (typeof productionLanguageCodes)[number];

export const productionLanguages: ReadonlyArray<{ code: ProductionLanguageCode; label: string }> = [
  { code: "en", label: "English" },
  { code: "nl", label: "Dutch" },
  { code: "de", label: "German" },
];

export function isProductionLanguageCode(value: unknown): value is ProductionLanguageCode {
  return typeof value === "string" && productionLanguageCodes.includes(value as ProductionLanguageCode);
}

export function productionLanguageLabel(code: ProductionLanguageCode): string {
  return productionLanguages.find((language) => language.code === code)!.label;
}
